// Shared between read-side consumers and ComponentCostSettings inside Insights4.
export const COMPONENT_COST_KEY = 'insightsComponentCostList';

// machine_name + component_name + cycle_time identifies one cost entry.
export const costKey = (row) => `${row.machine_name}|${row.component_name}|${row.cycle_time}`;
